import ClientSideLink from '@aboutyou/legacy-shared/src/ui/Navigation/ClientSideLink/ClientSideLink'
import { cdnImageUrl } from 'helpers/image'
import { useObserver } from 'mobx-react-lite'
import {
  AbsoluteTeaserBackground,
  ContentBannerSection,
  ContentClickableSection,
  ContentSectionCtaHolder,
  ContentSectionHeader,
  ContentSectionOverlay,
  ContentSectionSubHeader,
} from 'pages/Welcome/components/WelcomePageContentFocus/content/content-styles'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import { WelcomePageBlock } from 'store/features/config'

export const ContentUspBanner: FC<WelcomePageBlock> = ({
  headline,
  imagelink,
  link,
  subline,
}) => {
  const service = useService()

  const uspTile = useObserver(() =>
    service.staticImages.getById('welcomepage_usp_teaser'),
  )

  return (
    <ContentBannerSection
      noImage={!uspTile?.hash}
      data-testid="ContentUspBanner"
    >
      <ClientSideLink href={link}>
        <AbsoluteTeaserBackground
          src={cdnImageUrl(imagelink || '', { width: 1000 })}
          alt={uspTile?.alt || ''}
          height={100}
          width={100}
        />
        <ContentSectionOverlay clickable>
          <ContentClickableSection>
            <ContentSectionCtaHolder>
              <ContentSectionHeader>{headline}</ContentSectionHeader>
              <ContentSectionSubHeader>{subline}</ContentSectionSubHeader>
            </ContentSectionCtaHolder>
          </ContentClickableSection>
        </ContentSectionOverlay>
      </ClientSideLink>
    </ContentBannerSection>
  )
}
